import { ValidationResult } from "./interface.validation";

export class CpfValidator {
  static cpfFormat(item: any): ValidationResult {
    var CPF_REGEXP: any;
    if (item.value) {
      var tt: any = item.value.replace(/[^0-9]/gi, '');

      CPF_REGEXP = /([0-9]{11})/;

      if (item.value && !CPF_REGEXP.test(tt)) {
        return { "incorrectCpfFormat": true };
      }
    }

    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/cpf.validation.ts
 **/